<template>
  <div className="animated">
    <b-card class="animated fadeIn">
      <b-card-body>
        <h1>Stock Castaña Actual</h1>

        <v-server-table :url="url" :columns="columns" :options="options" :theme="theme" ref='table' id="dataTable">
          <template slot="afterFilter">
            <tr class="VueTables__no-results">
              <b-button  @click="resetFilters">Limpiar filtro</b-button>
            </tr>

            <tr v-if="loading" class="VueTables__no-results">
              <b-spinner v-if="loading" variant="primary" class="ml-2 mt-1" small label="Small Spinner"></b-spinner>
            </tr>

          </template>

          <template slot="condition" slot-scope="props">
            <b-badge pill :variant="getBadge(props.row.condition)">{{props.row.condition}}</b-badge>
          </template>
          <template slot="daystay" slot-scope="props">
            <div style="text-align: right">
              <b-badge pill :variant="getDaystayBadge(props.row.daystay)">
                {{props.row.daystay}}
              </b-badge>
            </div>
          </template>
          <div slot="beforeLimit">
            <download-excel
              class = "btn"
              :fetch   = "fetchData"
              :fields = "json_fields2"
              worksheet = "Stock"
              :name = "name"
              :before-generate = "startDownload"
              :before-finish = "finishDownload">
              <b-link>Descargar</b-link>
            </download-excel>

          </div>
          <div slot="net_kilograms" slot-scope="props">
            <div style="text-align: right">{{props.row.net_kilograms.format('0,0.00')}}</div>
          </div>

          <div slot="Unidades" slot-scope="props">
            {{parseFloat(props.row.exportable_kilograms / 25).toFixed(2)}}
          </div>

          <div slot="quantity" slot-scope="props">
            <div style="text-align: right">{{props.row.quantity}}</div>
          </div>

          <div slot="waybill_number" slot-scope="props">
            <div style="text-align: right">{{props.row.waybill_number}}</div>
          </div>
          <div slot="in_process" slot-scope="props">
            <div style="text-align: right" v-if="props.row.in_process">{{props.row.in_process}}</div>
          </div>
          <div slot="creation_date" slot-scope="props">
            <div style="text-align: right">{{props.row.creation_date | moment}}</div>
          </div>
          <div slot="waybill_date" slot-scope="props">
            <div style="text-align: right">{{props.row.waybill_date}}</div>
          </div>
          <div slot="last_inspection" slot-scope="props">

            <div v-if="props.row.last_inspection.inspection">
              <span :class="getBadgeInspection(props.row.last_inspection.color_status_pallet)">{{props.row.last_inspection.status_pallet}}</span>
            </div>

          </div>

        </v-server-table>
      </b-card-body>
    </b-card>

  </div>

</template>



<script>
  import Vue from 'vue'
  import {ServerTable, Event} from 'vue-tables-2'
  import JsonExcel from 'vue-json-excel'
  import moment from 'moment';
  import numeral from 'numeral';
  import locales from 'numeral/locales'

  numeral.locale('es');
  window.axios = require('axios');


  var d = new Date();

  Vue.use(ServerTable);
  Vue.component('downloadExcel', JsonExcel);

  export default {
    name: 'stockCastañaComponent',
    components: {
      ServerTable,
    },
    created () {
      this.getProducts();
      this.getCustomers();
    },
    mounted() {
      Event.$on('vue-tables.loading', ()=>{
          this.loading = true;
      });

      Event.$on('vue-tables.loaded',()=>{
          this.loading = false;
      });
     },
    data () {
      return {
        loading: false,
        json_meta: [
            [
                {
                    'key': 'charset',
                    'value': 'utf-8'
                }
            ]
        ],
        json_fields2: {
          'Exportadora':'client_customer_name',
          'Pallet':'pallet_number',
          'Lote':'lot_number',
          'Especie':'product_name',
          'Tipo':'product_type_name',
          'Huerto':'origin_name',
          'CSG':'origin_code',
          'Planta':'plant_name',
          'Condicion':'condition',
          'Variedad':'variety_name',
          'Formato':'container_name',
          'Fecha Creacion':'creation_date',
          'Cantidad':'quantity',


          'KN' : {
            field: 'net_kilograms',
            callback: (value) => {
              return numeral(parseFloat(value)).format('0.00');
            },
          },
          'Días estadía':'daystay',
          //'Especificaciones':'string_specs',
          'Documento':'document',
          // 'KB' : {
          //   field: 'gross_kilograms',
          //   callback: (value) => {
          //     return numeral(value).format('0.00');
          //   },
          // },
          'Fecha Guia':'waybill_date',
          'Guia Despacho':'waybill_number',
          'En Proceso':'in_process',
          'Inspeccion': 'last_inspection.status_pallet',
          'Mercado':'market_specs',
          'Calibre':'cal_specs',
          'FXK':'fx_specs',
        },
        columns: [
          'client_customer_name',
          'pallet_number',
          'lot_number',
          'product_name',
          'product_type_name',
          'condition',
          'variety_name',
          'container_name',
          'Unidades',
          'quantity',
          'net_kilograms',
          'creation_date',
          // 'waybill_number',
          // 'waybill_date',
          'daystay',
          //'string_specs',
          'origin_name',
          'in_process',
          'document',
          'last_inspection',
          'market_specs',
          'cal_specs',
          'fx_specs',
        ],
        selected: {
          product: "",
          product_type: "",
          client_customer: "",
          condition: "",
          month: d.getMonth()+1,
        },
        selectOptions:{
          products: [],
          product_types: [],
          client_customers: [],
          conditions:[
            {value: "", text: "-------"},
            {value: "Orgánico", text: "Orgánico"},
            {value: "Convencional", text: "Convencional"},
            {value: "Org. System Approach", text: "Org. System Approach"}
          ],
          months:[
            {value: 1, text: "Enero"},
            {value: 2, text: "Febrero"},
            {value: 3, text: "Marzo"},
            {value: 4, text: "Abril"},
            {value: 5, text: "Mayo"},
            {value: 6, text: "Junio"},
            {value: 7, text: "Julio"},
            {value: 8, text: "Agosto"},
            {value: 9, text: "Septiembre"},
            {value: 10, text: "Octubre"},
            {value: 11, text: "Noviembre"},
            {value: 12, text: "Diciembre"},
          ]
        },
        data: [],
        productSet: [],
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default',
        options: {
          rowClassCallback: function(row) {
            return row.is_complete ? 'font-weight-bold': row.in_process ? 'text-muted' : row.last_inspection.color_status_pallet ? 'text-'+row.last_inspection.color_status_pallet : ''
          },
          responseAdapter: function(resp) {
                  const results = resp.data.results;
                  const items = [];
                  for(let key in results){
                    const item = results[key];
                    results[key].waybill_date = moment(results[key].waybill_date).format('DD-MM-YYYY');
                    results[key].net_kilograms = numeral(parseFloat(results[key].net_kilograms));
                    items.push(item)
                  }

                   return {
                        data: items,
                        count: resp.data.count
                   };
                },
          texts: {
                filter: "Filtrar:",
                filterBy: 'Filtrar por {column}',
                count:' ',
                filterPlaceholder:"Buscar...",
                columns:'Columnas',
                limit:"Registros:",
            },
          perPage: 10,
          // columnsDropdown: true,
          filterByColumn: true,
          filterable:[
            "client_customer_name",
            "pallet_number",
            "lot_number",
            "product_type_name",
            "condition",
            "variety_name",
            "product_name",
            "container_name",
            "origin_name",
            "market_specs",
            "cal_specs",
            "fx_specs",
            "exportable_kilograms",
          ],
           headings: {
            client_customer_name: 'Exportadora',
            pallet_number: 'Pallet',
            product_name: 'Especie',
            product_type_name: 'Tipo Producto',
            condition: 'Condición',
            lot_number: 'Lote',
            in_process: 'En Proceso',
            variety_name: 'Variedad',
            container_name: 'Formato',
            quantity: 'Cantidad',

            net_kilograms: 'KN',
            daystay: 'Días estadía',
            //string_specs: 'Especificaciones',
            origin_name: 'Origen',
            document: 'Documento',
            creation_date: 'Fecha Creación',
            last_inspection:'Inspección',
            market_specs:'Mercado',
            cal_specs:'Calibre',
            fx_specs:'FXK',
          },
          debounce: 800,
          columnsDropdown:true,
          columnsDisplay: {
            document: 'not_desktop',
            product_name: 'not_desktop',
            product_type_name: 'min_desktop',
            string_specs: 'min_desktop',
            daystay: 'not_desktop',
            condition: 'min_desktop',
            lot_number: 'min_desktop',
            in_process: 'not_desktop',
            last_inspection: 'not_desktop',
          },
          sortable: [],
          sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
          pagination: {
            dropdown: false,
            chunk: 10
          }
        },

      }
    },
    filters: {
      moment (value) {
        return moment(value).format('DD-MM-YYYY')
      }
    },
    watch:{
      selected: {
         handler(val){
           this.getProductSet(this.selected.product)
         },
         deep: true
      }
    },
    computed:{
      name(){
        return "Stock " + moment(Date.now()).format('YYYYMMDD h:mm') + ".xls"
      },
      sumMarkedKilograms(){
        let total = 0;
        // total += this.data.reduce((acc, item) => acc + item.net_kilograms.value(), 0);
        total = numeral(total);
        return total;
      },
      url(){
        return '/api/v1/stock_chestnut/?' +
          'condition=' + this.selected.condition +
          '&client_customer=' + this.selected.client_customer +
          '&product_type=' + this.selected.product_type +
          '&variety__product=' + this.selected.product
      }
    },
    methods: {
      jsonToQueryString(json) {
        var result = {};
        for (var key in json) {
            if (json[key] !== '') {
                result[key] = json[key];
            }
        }

        var a = encodeURIComponent(JSON.stringify(result));

        return '/api/v1/stock_chestnut/?query=' + a;
      },
      resetFilters () {
        for (var key in this.$refs['table'].query) {
            this.$refs['table'].query[key] = '';
        }
        this.$refs['table'].refresh();
      },

      async fetchData(){
        const response = await this.$axios.get(this.jsonToQueryString(this.$refs.table.query));
        return response.data.results;
      },
      startDownload(){
          this.loading=true
      },
      finishDownload(){
          this.loading=false
      },


      getBadge (condition) {
        return condition === 'Orgánico' ? 'primary' : 'success';
      },
       getBadgeInspection (color) {
        return `badge badge-${color}`;
      },
      getDaystayBadge (daystay) {
        return daystay >= 10 ? 'danger'
        : daystay >= 5 ? 'warning'
          : daystay >= 3 ? 'success' : 'primary';
      },
      getProducts(){
        this.$axios.get ('/production/get_products/')
        .then(res => {
          // console.log(res)
          const data = res.data.data;
          const products = [];
          for(let key in data){
            const product = data[key];
            products.push(product)
          }
          this.selectOptions.products = products
        })
        .catch(error => console.log(errors))
      },
      getCustomers() {
        this.$axios.get ('/production/get_customers/')
          .then(res => {
            const data = res.data.data;
            const customers = [];
            for (let key in data) {
              const customer = data[key];
              customers.push(customer)
            }
            this.selectOptions.client_customers = customers
          })
          .catch(error => console.log(error))
      },
      getProductSet(a){
        this.$axios.get ('/production/get_product_set/'+ a )
        .then(res => {
          this.selectOptions.product_types = res.data.product_types
        })
        .catch(error => this.selected.product_type='')
      },
    },
  };
</script>

<style lang="scss">
  #dataTable {
    width: 100%;
    margin: 0 auto;

    .VuePagination {
      text-align: center;
      justify-content: center;
    }

    .table td {
      padding: 0.30em;
    }

    .vue-title {
      text-align: center ;
      margin-bottom: 10px;
    }

    .VueTables__search-field {
      display: flex;
    }
    .VueTables__search-field input {
      margin-left: 0.12rem;
    }

    .VueTables__limit-field {
      display: flex;
    }

    .VueTables__limit-field select {
      margin-left: 0.25rem !important;
    }

    .VueTables__table th {
      text-align: center;
      padding: 0.25rem;
    }

    .VueTables__child-row-toggler {
      width: 16px;
      height: 16px;
      line-height: 16px;
      display: block;
      margin: auto;
      text-align: center;
    }

    .VueTables__child-row-toggler--closed::before {
      content: "+";
    }
    .VueTables__columns-dropdown {
      padding-right: 20px;
    }
    .VueTables__date-filter {
      border: 1px solid #ccc;
      padding: 6px;
      border-radius: 4px;
      cursor: pointer;
    }
    .VueTables__number-field {
      border: 4px solid #ccc;
      padding: 6px;
      border-radius: 4px;
      cursor: pointer;
    }
    .VueTables__child-row-toggler--open::before {
      content: "-";
    }
  }

</style>
